export default __webpack_public_path__ + "static/media/blue_white.ec65724b.svg";